import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dust_down",
  "use": "icon-dust_down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dust_down\"><path d=\"M518.144 528.768v140.288h360.362667l-0.512-303.914667C877.994667 234.282667 770.56 128 637.781333 128H85.333333v313.856h354.005334c43.392-0.512 78.805333 43.434667 78.805333 86.912z m125.44 231.893333h89.941333V938.666667h-89.941333v-178.005334z m147.328 38.229334l77.909333-44.501334L938.666667 874.069333l-77.909334 44.501334-69.845333-119.68z m-351.872 75.093333l69.845333-119.68 77.952 44.458667-69.845333 119.68-77.952-44.501334z\" p-id=\"14074\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/dust_down.svg
// module id = KnhY
// module chunks = 250